export const CATALOG_BASE_FEATURE = 'catalog-base';
